<template>
    <Dropdown trigger="click" :transfer="true" @on-click="onChange">
        <a href="javascript:void(0)" class="f-green">
            {{select_text}}
            <Icon type="ios-arrow-down"></Icon>
        </a>
        <DropdownMenu slot="list">
            <DropdownItem v-for="(item,index) in list" :name="index" :key="index">{{item[key_name]}}</DropdownItem>
        </DropdownMenu>
    </Dropdown>
</template>

<script>
    export default {
        name: "myDropdown",
        model:{ //通过v-model传过来的参数
            prop: 'value',
            event: 'emitValue'
        },
        props:{
            list: {
                default: () => [],
                type: Array,
            },
            key_name: {
                default: "value",
                type: String,
            },
            value_name: {
                default: "key",
                type: String,
            },
            value: {
                default: "",
                type: String,
            }
        },
        data: function () {
            return{
            }
        },
        computed:{
            select_text:function() {
                var items = this.list.filter(item => item[this.value_name] == this.value);
                if(items.length > 0){
                    return items[0][this.key_name];
                }
                else{
                    return '';
                }
            },
        },
        methods: {
            onChange: function(data){
                this.$emit("emitValue",this.list[data][this.value_name]);
                this.$emit("onChange",this.list[data]);
            },
        }
    }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/myDropdown.vue